<template>
  <div class="session-lab-card">
    <div class="session-lab-card__wrapper">
      <div v-if="!isLoading" class="session-lab-card__body">
        <ELSCardCurrentSession
          v-if="currentLab.lab_type === 'els'"
          :currentLab="currentLab"
          :currentSession="currentSession"
          :setLabStatus="setLabStatus"
          :mixpanelEventPayload="mixpanelEventPayload"
          @close-modal="$emit('close-modal')"
        />
        <PTACardCurrentSession
          v-if="currentLab.lab_type === 'pta'"
          :currentLab="currentLab"
          :currentSession="currentSession"
          :setLabStatus="setLabStatus"
          :context="context"
          :mixpanelEventPayload="mixpanelEventPayload"
          @close-modal="$emit('close-modal')"
        />
      </div>
      <div v-else class="session-lab-card__body">
        <ActionLoader
          loaderClass="session-lab-card__loading-spinner"
          name="ball-clip-rotate"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ActionLoader from '@/components/shared/ActionLoader.vue'
import ELSCardCurrentSession from '@/components/modals/lab-modal/ELSCardCurrentSession.vue'
import PTACardCurrentSession from '@/components/modals/lab-modal/PTACardCurrentSession.vue'

export default {
  name: 'SessionLabCard',
  components: {
    ActionLoader,
    PTACardCurrentSession,
    ELSCardCurrentSession,
  },
  props: {
    setLabStatus: {
      type: Function,
      required: true,
    },
    isLoading: {
      type: Boolean,
    },
    context: {
      type: String,
      required: true,
    },
    mixpanelEventPayload: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState({
      currentLab: state => state.labs.currentLab,
      currentSession: state => state.labs.currentLabSession,
    }),
  },
}
</script>

<style lang="scss" scoped>
.session-lab-card {
  width: 100%;
  &__wrapper {
    color: var(--light-blue-gray);
    min-height: 160px;
    display: flex;
    flex: 1;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    background: linear-gradient(
      104.99deg,
      rgba(62, 63, 73, 0.7) -13.91%,
      rgba(62, 63, 73, 0) 100.48%
    );
    border-radius: 10px;
    padding: 30px;
    position: relative;
  }
  &__body {
    width: 100%;
    flex-grow: 1;
    display: inline-block;
    align-items: center;
    justify-content: center;
    @include tablet {
      display: flex;
    }
  }
  &__error-messages {
    width: 100%;
    margin: auto;
    margin-top: 20px;
    background: #2c2c2c;
    padding: 10px;
    padding: 20px 15px 20px 15px;
    border-radius: 10px;
    display: flex;
    flex: 1;
    align-items: center;
    .maintenance-title {
      width: 50%;
      text-align: left;
      font: normal normal bold 25px/24px 'CircularStd-Medium';
      letter-spacing: 0px;
      color: white;
      text-transform: capitalize;
      opacity: 1;
      display: flex;
      align-items: flex-end;
      justify-content: center;
      &__text {
        margin-bottom: -2px;
        margin-left: 8px;
      }
    }
    .maintenance-text {
      width: 50%;
      color: white;
      text-transform: uppercase;
      text-align: left;
      font-size: 10px;
      padding-top: 15px;
      a {
        color: #3e7aff;
      }
    }
  }
  &__lab-error {
    color: #727276;
    text-transform: initial;
    font-size: 14px;
  }
}
</style>
